import api from './auth';

// Admin Stats APIs
export const getAdminStats = (start = null, end = null) => {
    const params = {};
    if (start) params.start = start;
    if (end) params.end = end;
    return api.get('/api/admin/stats/summary', { params });
};

export const getTopCategories = (topN = 5) => {
    return api.get('/api/admin/stats/top-categories', {
        params: { topN }
    });
};

export const getCategoryTimeSeries = (start, end) => {
    return api.get('/api/admin/stats/category-timeseries', {
        params: { start, end }
    });
};

export const exportClassifications = (start = null, end = null) => {
    const params = {};
    if (start) params.start = start;
    if (end) params.end = end;
    return api.get('/api/admin/stats/export/classifications', {
        params,
        responseType: 'blob'
    });
};

// Admin Logs APIs
export const getAdminLogs = () => {
    return api.get('/api/admin/logs');
};

export const filterAdminLogs = (filterData) => {
    return api.post('/api/admin/logs/filter', filterData);
};

// User Management APIs
export const getUsers = () => {
    return api.get('/api/admin/users');
};

export const getUsersPaginated = (page = 0, size = 10, sort = 'createdAt,desc') => {
    return api.get('/api/admin/users/page', {
        params: { page, size, sort }
    });
};

export const changeUserStatus = (userId, isActive) => {
    return api.post(`/api/admin/users/${userId}/status`, { isActive });
};

export const changeUserRole = (userId, role) => {
    return api.post(`/api/admin/users/${userId}/role`, { role });
};

export const deleteUser = (userId) => {
    return api.delete(`/api/admin/users/${userId}`);
};

export const resetUserPassword = (userId, password) => {
    return api.post(`/api/admin/users/${userId}/reset-password`, { password });
};

export const createAdmin = (adminData) => {
    return api.post('/api/admin/users/create-admin', adminData);
};

export const createUser = (userData) => {
    return api.post('/api/admin/users/create', userData);
};

export const editUser = (userId, userData) => {
    return api.patch(`/api/admin/users/${userId}`, userData);
};

export const bulkChangeUserStatus = (userIds, isActive) => {
    return api.post('/api/admin/users/bulk/status', { userIds, isActive });
};

export const bulkDeleteUsers = (userIds) => {
    return api.post('/api/admin/users/bulk/delete', { userIds });
};

export const getUserDetails = (userId) => {
    return api.get(`/api/admin/users/${userId}/details`);
};

// Category Management APIs
export const getCategories = () => {
    return api.get('/api/admin/waste-categories');
};

export const getCategoryById = (id) => {
    return api.get(`/api/admin/waste-categories/${id}`);
};

export const createCategory = (categoryData) => {
    return api.post('/api/admin/waste-categories', categoryData);
};

export const updateCategory = (id, categoryData) => {
    return api.put(`/api/admin/waste-categories/${id}`, categoryData);
};

export const deleteCategory = (id) => {
    return api.delete(`/api/admin/waste-categories/${id}`);
};

export const reactivateCategory = (id) => {
    return api.post(`/api/admin/waste-categories/${id}/reactivate`);
};
